export const isConfirmObligationBatchResponse = (value) => {
    if (typeof value !== 'object' || value === null)
        return false;
    const result = value;
    return (typeof result.batchId === 'string' &&
        typeof result.idempotencyKey === 'string' &&
        /^\d{4}-\d{2}$/.test(result.period ?? '') &&
        Number.isInteger(result.createdCount) &&
        Number.isInteger(result.duplicateCount) &&
        result.status === 'completed' &&
        typeof result.idempotentReplay === 'boolean');
};
